
export default function ValuesSection() {
  const values = [
    {
      title: '品质至上',
      description: '严格把控每一个生产环节，确保产品品质始终如一，为消费者提供最优质的茶叶产品',
      icon: 'ri-award-line',
      features: ['严格质检', '工艺精湛', '标准统一', '持续改进'],
      color: 'from-blue-500 to-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      title: '传承创新',
      description: '传承千年茶文化精髓，结合现代科技创新，在保持传统的同时不断突破和发展',
      icon: 'ri-lightbulb-line',
      features: ['文化传承', '技术创新', '工艺革新', '理念更新'],
      color: 'from-slate-500 to-slate-600',
      bgColor: 'bg-slate-50'
    },
    {
      title: '生态责任',
      description: '坚持生态种植理念，保护茶山生态环境，实现可持续发展，为子孙后代留下绿水青山',
      icon: 'ri-leaf-line',
      features: ['生态种植', '环保生产', '可持续发展', '绿色经营'],
      color: 'from-blue-400 to-blue-500',
      bgColor: 'bg-blue-50'
    },
    {
      title: '客户至上',
      description: '以客户需求为导向，提供优质的产品和服务，建立长期稳定的合作关系',
      icon: 'ri-heart-line',
      features: ['需求导向', '服务优质', '诚信经营', '合作共赢'],
      color: 'from-gray-500 to-gray-600',
      bgColor: 'bg-gray-50'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            企业价值观
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            我们的核心价值观指导着公司的每一项决策和行动
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group hover:transform hover:scale-105"
            >
              <div className={`h-2 bg-gradient-to-r ${value.color}`}></div>
              <div className="p-6">
                <div className="flex items-start mb-4">
                  <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${value.color} flex items-center justify-center mr-4 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${value.icon} text-white text-2xl`}></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-800 mb-2">
                      {value.title}
                    </h3>
                  </div>
                </div>
                
                <p className="text-gray-600 leading-relaxed mb-4">
                  {value.description}
                </p>
                
                <div className="grid grid-cols-2 gap-2">
                  {value.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className={`${value.bgColor} rounded-lg p-2 text-center`}>
                      <span className="text-sm font-medium text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mission & Vision */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                <i className="ri-target-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold">企业使命</h3>
            </div>
            <p className="text-blue-100 text-lg leading-relaxed">
              传承千年茶文化，创新现代茶生活。我们致力于将云南优质茶叶推向全国乃至世界，让更多人感受到中国茶文化的博大精深，享受健康优质的茶叶产品。
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-slate-500 to-slate-600 rounded-2xl p-8 text-white">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mr-4">
                <i className="ri-eye-line text-white text-xl"></i>
              </div>
              <h3 className="text-2xl font-bold">企业愿景</h3>
            </div>
            <p className="text-slate-100 text-lg leading-relaxed">
              成为中国最具影响力的茶叶品牌，引领茶叶行业的创新发展。通过不断的技术创新和品质提升，让南滇古茶成为优质茶叶的代名词。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
